import type { Note } from '../domain/note'

export const NOTE_EXPORT_CONTRACT_VERSION = 1

export type NoteExportFormat = 'markdown' | 'json'

export interface NoteExportOptions {
  format: NoteExportFormat
  includeImages: boolean
  includeTags: boolean
}

export interface NoteExportSnapshot {
  id: string
  title: string
  body: string
  annotation: string
  userTags: string[]
  assetIds: string[]
  createdAt: number
  modifiedAt: number
}

export interface NoteExportManifest {
  contractVersion: 1
  requestedAt: string
  options: NoteExportOptions
  notes: NoteExportSnapshot[]
}

export function noteExportSnapshot(note: Note): NoteExportSnapshot {
  return {
    id: note.id,
    title: note.manualTitle?.trim() || note.derivedTitle.trim() || 'Untitled note',
    body: note.body,
    annotation: note.annotation,
    userTags: [...note.userTags],
    assetIds: [...note.assetIds],
    createdAt: note.createdAt,
    modifiedAt: note.modifiedAt,
  }
}
